export default __webpack_public_path__ + "static/media/UA.c05b6512.svg";